import React from "react";
import moment from "moment";
import { InPageEditableStandaloneField } from "components/MainSectionTemplate/InPageEditableStandaloneField";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";

interface Props {
  item: server.dto.ChecklistPresetItem
  onSave: (newQuestion: string, checklistPresetItemId: number) => void
}

const ChecklistItem = (props: Props) => {
  const { item } = props;

  return <>
    <div className="grow1">
      <InPageEditableStandaloneField
        value={item.question}
        onValueUpdated={newVal => {
          props.onSave(newVal, item.checklistPresetItemId);
        }}
        render={() => <span>{item.question}</span>}
        renderEdit={({ value, onChange, submit, cancel }) => <RequiredTextInput
          focusOnMount
          value={value}
          maxLength={serverReference.constants.checklist.maxQuestionLength}
          onChange={onChange}
          onEnter={submit}
          onEsc={cancel}
          validatorKey="question"
        />}
      />
      <div className="text-sublabel">
        {RESX.GeneralLabels.LastModified} {moment.utc(item.lastModifiedUtc).fromNow()}
      </div>
    </div>
  </>;
};

export default ChecklistItem;